import { NgModule } from '@angular/core';
import { LibSharedCommonModule } from '@solvace/common';
import { LibSharedComponentModule } from '@solvace/component';
import { TranslocoModule } from '@ngneat/transloco';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SvcButtonsModule } from '@solvace/component/svc-buttons';
import { SvcFiltersModule } from '@solvace/component/svc-filters';
import { SvcUserAvatarModule } from '@solvace/component/svc-user-avatar';
import { SvcMediaCarouselModule } from '@solvace/component/svc-media-carousel';
import { SvcCommentsInputComponent } from './components/svc-comments-input/svc-comments-input.component';
import { SvcCommentsChatComponent } from './components/svc-comments-chat/svc-comments-chat.component';
import { SvcCommentsViewerComponent } from './components/svc-comments-viewer/svc-comments-viewer.component';
import { SvcCommentsListComponent } from './components/svc-comments-list/svc-comments-list.component';
import { SvcQuillTextEditorModule } from '@solvace/component/svc-controls/svc-quill-text-editor';
import { SvcButtonModule } from '@solvace/component/svc-btn';
import { SvcButtonIconModule } from '@solvace/component/svc-btn-icon';
import { SvcReactionModule } from '../svc-reaction/svc-reaction.module';
import { SvcQuillEditorMentionModule } from '../svc-quill-editor-mention/svc-quill-editor-mention.module';
import { SvcAudioToTextButtonModule } from '../svc-audio-to-text-button/svc-audio-to-text-button.module';
import { SvcCommentsFeedComponent } from './components/svc-comments-feed/svc-comments-feed.component';
import { SvcCommentsMessageComponent } from './components/svc-comments-message/svc-comments-message.component';
import { SvcCommentsFeedSkeletonComponent } from './components/svc-comments-feed-skeleton/svc-comments-feed-skeleton.component';

@NgModule({
  declarations: [
    SvcCommentsInputComponent,
    SvcCommentsMessageComponent,
    SvcCommentsViewerComponent,
    SvcCommentsChatComponent,
    SvcCommentsListComponent,
    SvcCommentsFeedComponent,
    SvcCommentsFeedSkeletonComponent
  ],
  imports: [
    LibSharedCommonModule,
    LibSharedComponentModule,
    TranslocoModule,
    SvcQuillTextEditorModule,
    SvcQuillEditorMentionModule,
    SvcAudioToTextButtonModule,
    SvcUserAvatarModule,
    SvcButtonsModule,
    SvcButtonModule,
    SvcButtonIconModule,
    SvcReactionModule,
    SvcFiltersModule,
    SvcMediaCarouselModule,
    NgxSkeletonLoaderModule,
  ],
  exports: [
    SvcCommentsViewerComponent,
    SvcCommentsChatComponent,
    SvcCommentsListComponent,
    SvcCommentsFeedComponent,
    SvcCommentsFeedSkeletonComponent
  ],
})
export class SvcCommentsModule { }
